import React from "react";
import styles from "./SearchFilters.module.css";
import { Stack } from "@bookingcom/bui-react";
import { StopsFilterMobile } from "./FiltersSplit/StopsFilter";
import { AirlinesFilterMobile } from "./FiltersSplit/AirlinesFilter";
import { FlightTimesFilterMobile } from "./FiltersSplit/FlightTimesFilter";
import { DurationFilter } from "./FiltersSplit/DurationFilter";
import { BudgetPerAdultFilter } from "./FiltersSplit/BudgetPerAdultFilter";
import { AllDealsFilter } from "./FiltersSplit/AllDealsFilter";
import useProfiler from "../../../hooks/useProfiler";
import { useGetAvailableFilters } from "../SearchResults/components/boundsFilterHooks";

const SearchFiltersMobile = ({ shouldMoveBudgetFilter }: { shouldMoveBudgetFilter?: boolean }) => {
  const availableFilters = useGetAvailableFilters();
  const { isLoggedIn } = useProfiler();

  return (
    <div className={styles.contentWrapper}>
      {Object.keys(availableFilters).length > 0 ? (
        <Stack gap={8}>
          <StopsFilterMobile />
          {!shouldMoveBudgetFilter && <BudgetPerAdultFilter />}
          {isLoggedIn() && !!availableFilters.deals && <AllDealsFilter />}
          <AirlinesFilterMobile />
          <FlightTimesFilterMobile />
          <DurationFilter />
          {!!shouldMoveBudgetFilter && <BudgetPerAdultFilter />}
        </Stack>
      ) : null}
    </div>
  );
};

export default SearchFiltersMobile;
